export const BugNoteType: Record<string, number> = {
    TYPE_UNKNOWN: 0,
    TYPE_COMMENT: 1,
    TYPE_HISTORY: 2,
    TYPE_HISTORY_STATUS: 3,
    TYPE_HISTORY_PHASE: 4,
    TYPE_HISTORY_DOCUMENT: 5,
    TYPE_HISTORY_SIGNOFF: 6,
} as const;
export type BugNoteType = EnumLikeValueType<typeof BugNoteType>;